import { useState } from "react";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import { PromoApplicableProductDTO, PromoDTO } from "./useAllPromos.ts";

export type CreateBonusInput =
  | {
      type: "all_you_can_speak";
      lessonsCountedPerWeek: number;
      activeFrom?: string;
      activeTo?: string;
    }
  | { type: "extra_lessons"; extraLessons: number }
  | { type: "extra_weeks"; extraWeeks: number };

export type CreatePromoInput = {
  name: string;
  description?: string;
  bonuses: CreateBonusInput[];
  validFrom?: string;
  validTo?: string;
  applicableProducts?: PromoApplicableProductDTO[];
};

export function useCreatePromo() {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const [loading, setLoading] = useState(false);

  const createPromo = async (input: CreatePromoInput): Promise<PromoDTO> => {
    try {
      setLoading(true);
      const { data } = await createAxiosInstance().post<PromoDTO>(
        `/promos/`,
        input,
      );
      return data;
    } finally {
      setLoading(false);
    }
  };

  return { createPromo, loading };
}
